import React from "react";

// Customizable Area Start
import {
  IconButton,
} from "@mui/material";
import { chatLogo, connectLogo, pitchLogo, profileLogo, vbcLogo } from "./assets";
import Avatar from '@mui/material/Avatar';
// Customizable Area End

import NavigationMenuController, {
  Props,
} from "./NavigationMenuController";

const navItems = [
  { id: "chat", label: "Chat", icon: { chatLogo } },
  { id: "pitch", label: "Pitch", icon: { pitchLogo } },
  { id: "connect", label: "Connect", icon: { connectLogo } },
  { id: "vbc", label: "VBC", icon: { vbcLogo } },
  { id: "profile", label: "Profile", icon: { profileLogo } }
];

export default class NavigationMenu extends NavigationMenuController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start

  // Customizable Area End

  render() {
    // Customizable Area Start
    return (
      <div style={{
        width: '115px',
        height: '100%',
        minHeight: '100vh',
        backgroundColor: '#ffffff',
        borderRight: '1px solid #cbd5e1',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '60px',
        position: 'fixed'
      }}>
        {navItems.map((item) => {

          let color;
          if (item.label === "Profile") {
            color = '#596c2d';
          } else if (item.label === "VBC") {
            color = '#000000';
          } else {
            color = '#64748b';
          }

          return (
            <div
            data-test-id={`navigation-${item.id}`}
            onClick={() => this.handleNavigation(item.label)}
              key={item.id}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '5px',
                cursor: 'pointer',
                width: '72px',
                transition: 'all 0.3s ease'
              }}
            >
              <IconButton style={{
                width: '48px',
                height: '48px',
                borderRadius: item.label === "Profile" ? '100%' : '0',
              }}>
                <Avatar
                  src={Object.values(item.icon)[0]}
                  alt={item.label}
                  style={{
                    width: item.label === "VBC" ? '38px' : '32px',
                    height: item.label === "VBC" ? '36.48px' : '32px',
                    objectFit: 'contain'
                  }}
                />
              </IconButton>
              <span style={{
                fontFamily: 'Inter',
                fontSize: '18px',
                fontWeight: 500,
                letterSpacing: '-0.24px',
                color: color,
                textAlign: 'center'
              }}>
                {item.label}
              </span>
            </div>
          );
        })}
      </div>
    );
    // Customizable Area End
  }
}

// Customizable Area Start

// Customizable Area End
